import React, { useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Login from './pages/Login';
import AppContext from './context/AppContext';
import { DataContext } from './context/DataContext';
import ConfirmEmail from './pages/ConfirmEmail';
import ConfirmPhoneCode from './pages/ConfirmPhoneCode';
import PasswordReset from './pages/PasswordReset';
import StudentData from './pages/StudentData';

setupIonicReact();

const App: React.FC = () => {
  const [ appLoggedIn, setAppLoggedIn ] = useState( false );
  const [ appUserData, setAppUserData ] = useState( [] );
  const [ appToken, setAppToken ] = useState( '' );
  const [ appReloadSpeiseplan, setAppReloadSpeiseplan ] = useState( Math.random() );
  const [ appUserSpeiseplan, setAppUserSpeiseplan ] = useState( null );
  const [ appUserVerzehr, setAppUserVerzehr ] = useState( null );
  const [ appWarenkorb, setAppWarenkorb ] = useState( null );
  const [ appWarenkorbResetSignal, setAppWarenkorbResetSignal ] = useState( 0 );
  const [ appSelectedSchuelerId, setAppSelectedSchuelerId ] = useState<any>( null );
  
  const dataContextValue = {
    appLoggedIn:appLoggedIn,
    appLoggedInChange:setAppLoggedIn,
    appUserData:appUserData,
    appUserDataChange:setAppUserData,
    appTokenChange:setAppToken,
    appToken:appToken,
    appReloadSpeiseplan:appReloadSpeiseplan,
    appReloadSpeiseplanChange:setAppReloadSpeiseplan,
    appUserSpeiseplan:appUserSpeiseplan,
    appUserSpeiseplanChange:setAppUserSpeiseplan,
    appUserVerzehr:appUserVerzehr,
    appUserVerzehrChange:setAppUserVerzehr,
    appWarenkorb:appWarenkorb,
    appWarenkorbChange:setAppWarenkorb,
    appWarenkorbResetSignal:appWarenkorbResetSignal,
    appWarenkorbResetSignalChange:setAppWarenkorbResetSignal,
    appSelectedSchuelerId:appSelectedSchuelerId,
    appSelectedSchuelerIdChange:setAppSelectedSchuelerId
  }
  return(
  <IonApp>
    <DataContext.Provider value={ dataContextValue }>
    <AppContext />
      <IonReactRouter>
        <IonRouterOutlet>
          <Route exact path="/PR">
            <PasswordReset />
          </Route>
          <Route exact path="/PR/:resetHash">
            <PasswordReset />
          </Route>

          {appLoggedIn ? (
            <>
              <Route exact path="/home">
                <Home />
              </Route>
              <Route exact path="/student-data">
                <StudentData />
              </Route>
              <Route exact path="/">
                <Redirect to="/home" />
              </Route>
            </>
          ) : (
            <>
              <Route exact path="/login">
                <Login />
              </Route>
              <Route exact path="/confirm-email">
                <ConfirmEmail />
              </Route>
              <Route exact path="/confirm-phone">
                <Redirect to="/confirm-phone-code" />
              </Route>
              <Route exact path="/confirm-phone-code">
                <ConfirmPhoneCode />
              </Route>
              <Route exact path="/student-data">
                <StudentData />
              </Route>
              <Route exact path="/">
                <Redirect to="/login" />
              </Route>
              <Route path="*">
                <Redirect to="/login" />
              </Route>
            </>
          )}
        </IonRouterOutlet>
      </IonReactRouter>
    </DataContext.Provider>
  </IonApp>
  )
};

export default App;
